import React from 'react';

const PageKosteloosGebruik: React.FC = () => (
  <>
    <header className="page-header container">
      <h1>Wat kost het gebruik van infraplannen.nl</h1>
      <p className="header-sub-title">
        Infraplannen.nl is ontwikkeld in opdracht van alle netbeheerders die deelnemer zijn bij Stichting Mijn Aansluiting. 
        De deelnemende netbeheerders bieden het platform kosteloos aan de sector aan; de netbeheerders brengen hiervoor geen kosten in rekening.
      </p>
    </header>

    <section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* <Paper className="paper-content">content</Paper> */}
            <p>
              De deelnemende netbeheerders kunnen organisaties zoals onder andere gemeenten, provincies en waterschappen uitnodigen op infraplannen.nl om plannen te delen en af te stemmen. <a href="https://status.infraplannen.nl/" target="_blank" rel="noopener noreferrer">Bekijk welke netbeheerders deelnemen aan infraplannen.nl</a> en zorg dat u een uitnodiging ontvangt van één van de netbeheerders in uw regio. 
              Hebt u geen contactpersoon bij de netbeheerder, neem dan contact op via <a href="mailto:contact@infraplannen.nl">contact@infraplannen.nl</a>.
            </p>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default PageKosteloosGebruik;